// ============================================
// INTEGRAÇÃO EA• UPSELL OFFERS - ATUALIZAÇÃO AUTOMÁTICA DO CARRINHO
// ============================================
// Esta solução sincroniza o carrinho flutuante (cart-drawer) quando o app
// EA• Upsell Offers adiciona produtos ao carrinho, evitando que o cliente
// precise recarregar a página para ver os itens adicionados.
// ============================================

(function () {
    function log() { /* no-op */ }

    // Detecta se o app EA Upsell está presente/ativo
    function isEAUpsellInstalled() {
        // Heurísticas seguras: script do app e/ou elementos com marcação típica
        const hasScript = !!document.querySelector(
            'script[src*="ea-upsell"], script[src*="main-ea-upsell"], script[src*="ea_upsell"], script[src*="upsell-popups"], script[src*="easyapps"], script[src*="ea-boost"]'
        );
        const hasDomMarks = !!document.querySelector('[class*="ea-upsell"], [id*="ea-upsell"], [data-ea-upsell], [data-ea*="upsell"]');
        return hasScript || hasDomMarks;
    }

    // Inicialização real da integração (somente quando o app for detectado)
    function initEAUpsellIntegration() {
        log('[EA Upsell] Integração inicializada');

        // Função para atualizar o carrinho via evento nativo do tema
        async function refreshCart(openDrawer = false) {
        try {
            log('[EA Upsell] Atualizando carrinho...');
            
            // Busca o estado atual do carrinho via API do Shopify
            const response = await fetch('/cart.js');
            const cartData = await response.json();
            
            log('[EA Upsell] Dados do carrinho:', cartData);
            
            // Dispara o evento customizado que o tema usa para atualizar o carrinho
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', {
                    bubbles: true,
                    detail: {
                        cart: cartData,
                        openMiniCart: openDrawer, // Abre o carrinho se solicitado
                    }
                })
            );
            
            log('[EA Upsell] Carrinho atualizado com sucesso!');
        } catch (error) {
            /* swallow */
        }
    }

    // ============================================
    // EVENTOS DO EA• UPSELL OFFERS
    // ============================================
    // Lista completa de eventos possíveis que o app pode disparar.
    // Testamos múltiplos nomes porque a documentação do app pode variar.
    
    const possibleEvents = [
        'ea_upsell_item_added',           // Nome hipotético 1
        'ea_upsell:item:added',           // Nome hipotético 2  
        'eaUpsellItemAdded',              // Nome hipotético 3 (camelCase)
        'upsell:item:added',              // Nome genérico
        'cart:item:added',                // Nome alternativo
        'ajaxCart:added',                 // Padrão comum em apps Shopify
        'product:added',                  // Outro padrão comum
    ];

    // Registra listeners para todos os eventos possíveis
    possibleEvents.forEach(eventName => {
        document.addEventListener(eventName, function(event) {
            log(`[EA Upsell] Evento capturado: ${eventName}`, event);
            refreshCart(true); // true = abre o carrinho automaticamente
        });
    });

    // ============================================
    // FALLBACK: MONITORAMENTO DE REQUESTS AJAX
    // ============================================
    // Intercepta chamadas fetch/XMLHttpRequest para /cart/add.js
    
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
        const url = args[0];
        
        return originalFetch.apply(this, args).then(response => {
            // Se foi um POST para /cart/add.js, atualiza o carrinho
            if ((url.includes('/cart/add.js') || url.includes('/cart/change.js'))) {
                log('[EA Upsell] Requisição de carrinho detectada:', url);
                // Aguarda um pouco para garantir que o backend processou
                setTimeout(() => refreshCart(true), 500);
            }
            
            return response;
        });
    };

    // Intercepta XMLHttpRequest também (para compatibilidade com jQuery)
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;
    
    XMLHttpRequest.prototype.open = function(method, url) {
        this._url = url;
        return originalXHROpen.apply(this, arguments);
    };
    
    XMLHttpRequest.prototype.send = function() {
        this.addEventListener('load', function() {
            if (this._url && (this._url.includes('/cart/add.js') || this._url.includes('/cart/change.js'))) {
                log('[EA Upsell] XHR para carrinho detectado:', this._url);
                setTimeout(() => refreshCart(true), 500);
            }
        });
        
        return originalXHRSend.apply(this, arguments);
    };

    // ============================================
    // API PÚBLICA PARA TESTE E DEBUG
    // ============================================
    // Disponibiliza funções globalmente para facilitar testes no console
    window.eaUpsellDebug = {
        refreshCart: refreshCart,
        testRefresh: () => {
            refreshCart(true);
        }
    };

    log('[EA Upsell] Integração pronta! Use window.eaUpsellDebug.testRefresh() para testar.');
    }

    // Bootstrap: só iniciar quando o app for detectado
    function bootstrap() {
        if (isEAUpsellInstalled()) {
            initEAUpsellIntegration();
            return true;
        }
        return false;
    }

    if (!bootstrap()) {
        // Tenta novamente após load + pequeno atraso (app pode injetar scripts tardiamente)
        window.addEventListener('load', () => {
            setTimeout(() => {
                if (bootstrap()) return;
            }, 1200);
        });

        // Observa inserção de scripts/DOM para detectar o app e inicializar
        const mo = new MutationObserver(() => {
            if (bootstrap()) {
                try { mo.disconnect(); } catch(_) {}
            }
        });
        try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch(_) {}
    }
})();
